// eslint-disable-next-line no-use-before-define
import { useQuery } from '@apollo/client';
import { Link } from '@mui/material';
import { GET_ATTACHMENT_URL } from 'op-components/DocumentUpload/queries';
import { PatientAttachment } from 'op-interfaces/PatientInterfaces';
import { openSafeUrl } from 'op-utils/openSafeUrl';

interface Props {
  attachment: PatientAttachment;
  children: React.ReactNode;
  setError?: (error: string) => void;
}

const S3DownloadLink = ({ attachment, children, setError }: Props): JSX.Element => {
  // Provides a link to an S3 object that will call the backend to check S3 status before opening the object in a new tab

  const { refetch: refetchAttachmentUrl } = useQuery(GET_ATTACHMENT_URL, {
    skip: true, // Skip initial query since we only want to fetch when needed
  });

  const handleAttachmentClick = async (attachmentId: string) => {
    try {
      const { data } = await refetchAttachmentUrl({ attachmentId });
      const s3Status = data.attachment.s3Status;

      if (s3Status.isSafe && openSafeUrl(s3Status.url)) return;
      setError && setError(s3Status.errorMessage || 'Error accessing file');
    } catch (error) {
      setError && setError('Error accessing file');
    }
  };

  if (!attachment?.id) return <></>;

  return (
    <Link
      component="a"
      data-testid={'s3Link-' + attachment.id}
      onClick={(e) => {
        e.preventDefault();
        handleAttachmentClick(attachment.id);
      }}>
      {children}
    </Link>
  );
};

export default S3DownloadLink;
